import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/notifications/notification.service";
import { SessionService } from "src/app/session.service";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "src/app/shared/dialogs/filter-table-dialog/filter-table-dialog.component";
import { UiService } from "src/app/ui/ui.service";
import { GeofenceDTO } from "../Geofence";
import { GeofenceService } from "../geofence.service";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { BehaviorSubject, merge, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  first,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { DataSource } from "@angular/cdk/table";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { CollectionViewer } from "@angular/cdk/collections";
import { FormControl } from "@angular/forms";
import { LocalStorageService } from "src/app/storage/local-storage.service";
@Component({
  selector: "app-geofences-list",
  templateUrl: "./geofences-list.component.html",
  styleUrls: ["./geofences-list.component.scss"],
})
export class GeofencesListComponent implements OnInit {
  pageSizeOptions = pageSizeOptions;
  searchValueControl = new FormControl("");
  geofences!: GeofenceDTO[];
  columns = [
    { code: "id", name: "ID" },
    { code: "name", name: "Geofence Name", filter: true, selected: true },
    { code: "competitor", name: "Competitor" },
    { code: "options" },
  ];
  displayedColumns = this.columns.map((column) => column.code);
  perPage: number = 20;

  @ViewChild("geofencesTable") geofencesTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  hasGeofencesWrite: boolean = false;
  hasGeofenceDetail: boolean = false;
  private onComponentDestroy = new Subject();
  @ViewChild(ElementLoaderDirective)
  geofenceElementLoader!: ElementLoaderDirective;
  geofenceDataSource!: GeofencesDataSource;
  onFilterColumnChange = new Subject();

  constructor(
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private GeofenceService: GeofenceService,
    private SessionService: SessionService,
    private NotificationService: NotificationService,
    private uiService: UiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private localStorageSvc: LocalStorageService,
  ) {}

  ngOnInit(): void {
    // this.geofences = this.activatedRoute.snapshot.data.geofences.records;
    // this.geofenceDataSource = new MatTableDataSource(this.geofences);
    // this.geofenceDataSource.filterPredicate = (data: any, filter: string) => {
    //   let found = false;
    //   for (let column of this.selectedColumns) {
    //     let rowValue = data[column];
    //     if (typeof rowValue === "number") {
    //       rowValue = rowValue.toString();
    //     }
    //     if (typeof rowValue === "string") {
    //       if (rowValue?.trim().toLowerCase().indexOf(filter) !== -1) {
    //         found = true;
    //       }
    //     }
    //   }

    //   return found;
    // };

    this.perPage = this.localStorageSvc.pageSize || 20;

    this.hasGeofencesWrite =
      this.activatedRoute.snapshot.data.permissions.hasGeofencesWrite;
    this.hasGeofenceDetail =
      this.activatedRoute.snapshot.data.permissions.hasGeofenceDetail;
  }

  ngAfterViewInit() {
    // this.geofencesTable.renderRows();
    // this.geofenceDataSource.sort = this.sort;
    // this.geofenceDataSource.paginator = this.paginator;

    this.geofenceDataSource = new GeofencesDataSource(
      this.GeofenceService,
      this.paginator,
      this.geofenceElementLoader,
    );

    this.loadGeofencesPage().pipe(first()).subscribe();

    merge(
      this.sort.sortChange.pipe(tap(() => (this.paginator.pageIndex = 0))),
      this.paginator.page,
      this.onFilterColumnChange,
      this.searchValueControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
      ),
    )
      .pipe(
        debounceTime(300),
        switchMap(() => this.loadGeofencesPage().pipe(first())),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe();

    this.ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue;
  }

  applyFilter() {
    // this.geofenceDataSource.filter = this.searchValue.trim().toLowerCase();
  }

  createNewGeofence() {
    this.router.navigate(["create"], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  toggleFilterDialog() {
    this.dialog
      .open(FilterTableDialogComponent, {
        data: {
          columns: this.columns,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.columns = result;
          this.onFilterColumnChange.next();
        }
      });
  }

  edit(geofence: GeofenceDTO) {
    this.router.navigate([geofence.id], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  delete(geofence: GeofenceDTO) {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this geofence ( ${geofence.name} )?`,
            warning: "Warning: this is not reversible!",
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.uiService
            .waitForEvent(
              this.GeofenceService.deleteGeofence(
                this.currentAccount!.accountID,
                geofence.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar(
                  "Geofence deleted",
                );
                this.loadGeofencesPage().pipe(first()).subscribe();
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting geofence",
                );
              },
            );
        }
      });
  }

  loadGeofencesPage() {
    const sort = this.buildSort();

    return this.geofenceDataSource.loadGeofences(
      this.SessionService.currentAccountValue!.accountID,
      {
        page: this.paginator.pageIndex,
        perPage: this.paginator.pageSize,
        keyword: this.searchValueControl.value ?? "",
        forCount: true,
        sort,
        filter_columns: this.columns
          .filter((column) => column.selected)
          .map((column) => column.code),
      },
    );
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      sort.push(`${this.sort.active}:${this.sort.direction}`);
    }
    return sort;
  }

  onPageChange(e: PageEvent){
    this.localStorageSvc.pageSize = e.pageSize;
    this.perPage = e.pageSize;
  }
}

export class GeofencesDataSource implements DataSource<any> {
  private geofencesSubject = new BehaviorSubject<any[]>([]);

  constructor(
    private GeofenceService: GeofenceService,
    private paginator: MatPaginator,
    private geofencesElementLoader: ElementLoaderDirective,
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.geofencesSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.geofencesSubject.complete();
  }

  loadGeofences(masterAccountID: number, queryParams: any) {
    return this.geofencesElementLoader
      .waitForEvent(
        this.GeofenceService.getGeofences(masterAccountID, queryParams).pipe(
          catchError(() => of({ count: 0, records: [] })),
        ),
      )
      .pipe(
        tap((filter: any) => {
          this.paginator.length = filter.count;
          const records = filter.records;

          this.geofencesSubject.next(records);
        }),
      );
  }

  
}
